import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-logo-display',
  imports: [],
  templateUrl: './logo-display.component.html',
  styleUrl: './logo-display.component.scss'
})
export class LogoDisplayComponent {
  @Input()
  logoHeuresInsertionUrl : string
  }
